import React, { useEffect, useState } from 'react';

import { FaceSample } from '@vlabs/uikit';

import st from './ChangeFacePhoto.module.sass';
import { changeFacePhotoAndAttribute } from './changeFacePhotoAndAttribute';
import { SampleIdExtractor } from './SampleIdExtractor';
import { getFace } from '@vlabs/api/luna-api/client';

interface ChangeFacePhotoButtonProps {
  faceId: string;
  onChangeFacePhoto: (callback: () => Promise<void>) => void;
}

function ChangeFacePhoto({
  faceId,
  onChangeFacePhoto,
}: ChangeFacePhotoButtonProps): React.JSX.Element {
  const [faceSampleURL, setFaceSampleURL] = useState<string>();

  useEffect(() => {
    getFace(faceId, { targets: ['avatar'] }).then(({ avatar }) => {
      setFaceSampleURL(`/api/lp5${avatar}`);
    });
  }, [faceId]);

  const onExtractSampleId = async (sampleId: string) => {
    const newFaceSampleURL = `/api/lp5/6/samples/faces/${sampleId}`;
    setFaceSampleURL(newFaceSampleURL);
    onChangeFacePhoto(async () => {
      changeFacePhotoAndAttribute(faceId, sampleId);
    });
  };

  return (
    <div className={st.ChangeFacePhoto}>
      <FaceSample
        className={st.FaceSample}
        size="large"
        src={faceSampleURL}
      />
      <SampleIdExtractor
        faceId={faceId}
        onExtractSampleId={onExtractSampleId}
      />
    </div>
  );
}

export { ChangeFacePhoto };
